'use client';

export default function GlobalError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div data-theme="dark" data-page-theme="dark" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0a0a14', color: '#fff', fontFamily: 'system-ui, sans-serif', padding: '24px', textAlign: 'center' }}>
      <p style={{ fontSize: '2rem', marginBottom: '12px' }}>⚠️</p>
      <p style={{ fontWeight: 700, fontSize: '18px', marginBottom: '8px' }}>Une erreur inattendue s&apos;est produite</p>
      <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '14px', marginBottom: '24px' }}>Rechargez la page ou réessayez.</p>
      <button onClick={reset} style={{ padding: '12px 28px', borderRadius: '12px', background: '#6366f1', color: '#fff', border: 'none', fontWeight: 600, fontSize: '15px', cursor: 'pointer' }}>
        Réessayer
      </button>
    </div>
  );
}
